import styled from '@emotion/styled';
import React, { useMemo } from 'react';
import { useCountdown, formatCountdown } from 'hooks/useCountdown';

const COUNTDOWN_BOX_BASE = {
  fontWeight: 500,
  fontSize: 32,
} as const;

const COUNTDOWN_BOX_RESPONSIVE = {
  width: 80,
  height: 80,
  fontSize: 40,
} as const;

const CountdownRow = styled.div(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: theme.spacing(2),
}));

const CountdownBox = styled.div(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: theme.borderRadius.large,
  backgroundColor: theme.colors.brand.lightBlue,
  color: theme.colors.brand.darker,
  width: 60,
  height: 60,
  ...COUNTDOWN_BOX_BASE,
  [theme.media.createObjectMediaQuery({ from: 3 })]: {
    width: COUNTDOWN_BOX_RESPONSIVE.width,
    height: COUNTDOWN_BOX_RESPONSIVE.height,
    fontSize: COUNTDOWN_BOX_RESPONSIVE.fontSize,
  },
}));

const CountdownColon = styled.span(({ theme }) => ({
  color: theme.colors.brand.darker,
  ...COUNTDOWN_BOX_BASE,
  [theme.media.createObjectMediaQuery({ from: 3 })]: {
    fontSize: COUNTDOWN_BOX_RESPONSIVE.fontSize,
  },
}));

export interface OfferTimerProps {
  endDate: number;
}

export const OfferTimer: React.FC<OfferTimerProps> = ({ endDate }) => {
  const countdownEndDate = useMemo(() => new Date(endDate), [ endDate ]);
  const timeLeftMs = useCountdown(countdownEndDate);
  const [ hoursStr, minutesStr, secondsStr ] = formatCountdown(timeLeftMs).split(':');

  return (
    <CountdownRow>
      <CountdownBox>{secondsStr}</CountdownBox>
      <CountdownColon>:</CountdownColon>
      <CountdownBox>{minutesStr}</CountdownBox>
      <CountdownColon>:</CountdownColon>
      <CountdownBox>{hoursStr}</CountdownBox>
    </CountdownRow>
  );
};
